export default "__VITE_ASSET__22551d1c__"